import React from 'react';
import { PropTypes } from 'prop-types';
import { compose, pure } from 'recompose';
import LoadSpinner from 'components/LoadSpinner';

import KeyBoardSelector from 'components/KeyBoardSelector';
import AddressSuggestionItem from 'components/AddressModal/components/AddressSuggestionItem';
import VenueSuggestionItem from 'components/AddressModal/components/VenueSuggestionItem';

import { LoadingWrapper } from 'components/form/AddressSelector/styled';

const enhance = compose(pure);

const VENUE_SUGGESTION_TYPE = 'venue';

const AddressSuggestionsSelector = ({
  options,
  className,
  selectAddress,
  loading,
  listenerElement,
  t,
  hasError,
  searchText,
  suggestionType,
}) => {
  return options && options.length <= 0 ? null : (
    <KeyBoardSelector
      listenerElement={listenerElement}
      className={className}
      minWidth="100%"
    >
      {!hasError &&
        !loading &&
        options.map((addr, idx, arr) => (
          <>
            {suggestionType === VENUE_SUGGESTION_TYPE ? (
              <VenueSuggestionItem
                key={`venue-${addr.idx}`}
                value={addr}
                onClick={selectAddress}
              />
            ) : (
              <AddressSuggestionItem
                key={`address-${addr.idx}`}
                value={addr}
                searchText={searchText}
                onClick={selectAddress}
              />
            )}
            {idx !== arr.length - 1 ? (
              <hr className="suggestion-separator" />
            ) : null}
          </>
        ))}

      {!hasError && !!loading && (
        <div className="loading">
          <LoadingWrapper>
            <LoadSpinner
              loadText={t('load_text')}
              loadTitle={t('load_title')}
              skin="standar"
            />
          </LoadingWrapper>
        </div>
      )}
    </KeyBoardSelector>
  );
};

AddressSuggestionsSelector.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  selectAddress: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  listenerElement: PropTypes.instanceOf(Element).isRequired,
  t: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  inputValue: PropTypes.string,
  suggestionType: PropTypes.string,
};

AddressSuggestionsSelector.defaultProps = {
  className: '',
  options: [],
  loading: false,
  hasError: false,
  inputValue: '',
  suggestionType: '',
};

export default enhance(AddressSuggestionsSelector);
